// @flow
import React from 'react';
import styled, {css} from 'styled-components';
import { Button as BSButton } from 'reactstrap';
import { ThemeColors } from 'trustar-2.0/themes/default';
import type { ColorType } from 'trustar-2.0/types';
import type { IconPropsType } from './types';


export const Icon = (props: IconPropsType) => {
  const I = styled.i`
    font-family: 'Linearicons' !important;
    speak: none;
    font-style: normal;
    font-weight: ${props => props.fontWeight};
    font-size: ${props => props.fontSize};
    font-variant: normal;
    text-transform: none;
    line-height: 1;

    /* Better Font Rendering =========== */
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    &:before{
      content: "\\${props => props.icon.content}";
    }
    
    ${props => props.disabled && css`
        opacity: 0.8;
        pointer-events: none;
    `}
  `;
  return <I className='icon' {...props} />;
};

Icon.defaultProps = { fontSize: '1rem', fontWeight: 'normal', lineHeight: '1rem'};

export const CircleIcon = styled(Icon)`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.backgroundColor};
    color: ${props => props.color};
    min-width: ${props => props.fontSize ? `${Number.parseFloat(props.fontSize) * 1.5}rem` : '1.5rem'};
    border-radius: 50%;
    padding: ${props => props.fontSize ? `${Number.parseFloat(props.fontSize) / 6}rem` : '0.25rem'}; 
    line-height: normal;
    -webkit-text-stroke-width: 1px;


    &:before {
      float: none;
      width: auto;
    }
  `;

CircleIcon.defaultProps = {
  color: ThemeColors.WHITE.hex,
  backgroundColor: ThemeColors.BLACK.hex,
};


export default Icon;


// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/components/Icon/components.js